import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { WebAccessControlCustomPagesFormController } from '../controller/WebAccessControlCustomPagesFormController';
import { WacPagesRecord } from '../../webAccessControlCustomPagesApp/types';

export class WebAccessControlCustomPagesFormComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: WebAccessControlCustomPagesFormController,
    });
  }

  get isVisible(): boolean | undefined {
    if (this.hasAttribute('data-is-visible')) {
      const value = this.getAttribute('data-is-visible');
      return value ? JSON.parse(value) : undefined;
    }
    return undefined;
  }

  set isVisible(value: boolean | undefined) {
    if (value) {
      this.setAttribute('data-is-visible', 'true');
    } else {
      this.removeAttribute('data-is-visible');
    }
  }

  set customPage(value: WacPagesRecord | undefined) {
    if (typeof value === 'undefined') {
      this.removeAttribute('data-custom-page');
    } else {
      this.setAttribute('data-custom-page', JSON.stringify(value));
    }
  }

  get customPage(): WacPagesRecord | undefined {
    if (this.hasAttribute('data-custom-page')) {
      const value = this.getAttribute('data-custom-page');
      return value ? JSON.parse(value) : undefined;
    }
    return undefined;
  }
}
